import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Button } from '@orijinworks/frontend-commons';

const ConfirmGenerateModal = ({
  open,
  title,
  message,
  confirmLabel,
  loading,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button color="default" variant="outlined" disabled={loading} onClick={onCancel}>
        Cancel
      </Button>
      <Button color="primary" variant="contained" disabled={loading} onClick={onConfirm}>
        {loading ? 'Generating…' : confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

ConfirmGenerateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

ConfirmGenerateModal.defaultProps = {
  loading: false,
};

export default ConfirmGenerateModal;
